const ChartColours = [
	"#EA611C",
	"#F2B827",
	"#00BB87",
	"#B13EF0",
	"#FF5786",
	"#FBD5CC",
	"#1292FE",
	"#DCE84D",
	"#145A29",
	"#FF77DC",
	"#0508FF",
	"#CE496F",
];

export default ChartColours;
